<template>
  <div v-if="customBlockData !== undefined">
    <menu-content-container
      :chip="customBlockData.name"
      chip-secondary
      :border-bottom="false"
    >
    </menu-content-container>

    <menu-content-container border-full>
      <TButton @click="openModal">{{
        customBlockData.dialogButtonText
      }}</TButton>
    </menu-content-container>

    <menu-content-container :border-bottom="false">
      <content-row>
        <hideOnMobile></hideOnMobile>
      </content-row>
      <content-row :margin-bottom="20" :margin-top="16">
        <hideOnDesktop></hideOnDesktop>
      </content-row>
    </menu-content-container>
  </div>
</template>

<script setup lang="ts">
  import hideOnMobile from "./components/hideOnMobile.vue";
  import hideOnDesktop from "./components/hideOnDesktop.vue";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { useCustomBlocksStore } from "@/stores/customBlocksStore";
  import { CustomBlockData } from "types/ContentBlock/IContentBlockOptions";
  import { TButton } from "@topol/twig-ui";
  import { computed } from "vue";

  const mjmlStore = useMjmlStore();
  const customBlocksStore = useCustomBlocksStore();

  const customBlocks = computed(() => {
    return customBlocksStore.customBlocks;
  });

  const customBlockData = computed(() => {
    if (block.value !== undefined) {
      return customBlocks.value.find((b) => b.key === block.value?.key);
    }

    return undefined;
  });

  const block = computed(() => {
    return mjmlStore.getActiveBlock as CustomBlockData | undefined;
  });

  const customBlockDataWithCurrentContent = computed(() => {
    return {
      ...customBlockData.value,
      content: block.value?.content,
    };
  });

  function openModal() {
    const message = {
      type: "callback",
      action: "onOpenCustomBlockDialog",
      data: {
        args: [customBlockDataWithCurrentContent.value],
      },
    };

    window.parent.postMessage(JSON.parse(JSON.stringify(message)), "*");
  }
</script>
